import React, { useState, useEffect } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { PlusCircle, Save2, Trash, PersonLinesFill, CashCoin, Bank, CardHeading, Diagram2, Diagram2Fill, CreditCard2Front, GeoAlt, EnvelopeAt, Telephone, CardText, GlobeAmericas, Geo, Map, CardList, MapFill, Calendar3, HandThumbsUp } from 'react-bootstrap-icons'
import { Button, Form, Row, Col } from 'react-bootstrap'

import SearchSelect from '../components/form/SearchSelect'
import InputNumber from '../components/form/InputNumber'
import InputDate from '../components/form/InputDate'

import ProjectsService from '../services/ProjectsService'
import PartnersService from '../services/PartnersService'
import EntitiesService from '../services/EntitiesService'

import { AlertMsg, AlertError, AlertLoading } from '../helpers/AlertHelper'
import { formatDate } from "../helpers/momentHelper"

const ProjectsForm = (props) => {

    const intl = useIntl()
    const [elementId, setElementId] = useState(props.elementId)
    const [action, setAction] = useState(props.action)
    const [name, setName] = useState('')
    const [reference, setReference] = useState('')
    const [startDate, setStartDate] = useState(formatDate(Date.now(), 'YYYY-MM-DD'))
    const [endDate, setEndDate] = useState(formatDate(Date.now(), 'YYYY-MM-DD'))
    const [programName, setProgramName] = useState('')
    const [programAction, setProgramAction] = useState('')
    const [budget, setBudget] = useState('')
    const [eligiblePercent, setEligiblePercent] = useState('')
    const [entityId, setEntityId] = useState('')
    const [entityErrorKey, setEntityErrorKey] = useState('')
    const [entitiesList, setEntitiesList] = useState([])
    const [partnersId, setPartnersId] = useState([])
    const [partnersList, setPartnersList] = useState([])
    const [partnersErrorKey, setPartnersErrorKey] = useState('')
    const [description, setDescription] = useState('')
    const [buttonTitle, setButtonTitle] = useState('')
    const [inputDisabled, setInputDisabled] = useState(false)
    const [formValid, setFormValid] = useState(false)

    const [showMsg, setShowMsg] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false)
    const [error, setError] = useState(false)

    // Fetch entities
    const fetchEntities = async () => {
        try {
            const response = await EntitiesService.getEntities(1, '', 2000)
            setEntitiesList(response.data.entities)
        } catch (err) {
            setError(err)
        }
    }

    // Fetch partners
    const fetchPartners = async () => {
        try {
            const response = await PartnersService.getPartners(1, '', 2000)
            setPartnersList(response.data.partners)
        } catch (err) {
            setError(err)
        }
    }

    const getData = async () => {
        await ProjectsService.getProject(elementId).then(
            response => {
                setEntityId(response.data.entityId || '')
                setName(response.data.name || '')
                setReference(response.data.reference || '')
                setStartDate(formatDate(response.data.startDate, 'YYYY-MM-DD'))
                setEndDate(formatDate(response.data.endDate, 'YYYY-MM-DD'))
                setProgramName(response.data.programName || '')
                setProgramAction(response.data.programAction || '')
                setBudget(response.data.budget || '')
                setEligiblePercent(response.data.eligiblePercent || '')
                setPartnersId(response.data.partnersId || [])
                setDescription(response.data.description || '')
                setIsLoaded(true)
            },
            error => {
                setError(error)
            })
    }

    useEffect(() => {
        fetchEntities()
        fetchPartners()

        if (elementId) {
            getData()
        }

        switch (action) {
            case 'edit':
                setButtonTitle(<FormattedMessage id="textSave" defaultMessage="Save" />)
                break
            case 'delete':
                setButtonTitle(<FormattedMessage id="textDelete" defaultMessage="Delete" />)
                setInputDisabled(true)
                break
            default:
                setButtonTitle(<FormattedMessage id="textAdd" defaultMessage="Add" />)
        }

    }, [])

    const onSubmit = () => {
        props.onSubmit()
    }

    const handleInputChange = (e) => {
       const { name, value } = e.target;
    
        if (name === 'entityId') {
            setEntityErrorKey(''); 
        }
        if (name === 'partnersId'){
            setPartnersErrorKey('')
        } 

        setFieldValue(name, value);
    }

    const setFieldValue = (fieldName, value) => {
        switch (fieldName) {
            case 'name':
                setName(value)
                break
            case 'reference':
                setReference(value)
                break
            case 'entityId':
                setEntityId(value)
                break
            case 'startDate':
                if (endDate && new Date(value) > new Date(endDate)) {
                    break
                } else {
                    setStartDate(value)
                    break
                }
            case 'endDate':
                if (startDate && new Date(value) < new Date(startDate)) {
                    break
                } else {
                    setEndDate(value)
                    break
                }
            case 'programName':
                setProgramName(value)
                break
            case 'programAction':
                setProgramAction(value)
                break
            case 'budget':
                setBudget(value)
                break
            case 'eligiblePercent':
                setEligiblePercent(value)
                break
            case 'partnersId':
                setPartnersId(value)
                break
            case 'description':
                setDescription(value)
                break
        }
    }

    const handleSubmit = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    console.log("action:", action)
    console.log("elementId:", elementId)

 
    setEntityErrorKey('')
    setPartnersErrorKey('')

    const form = e.currentTarget

    
    let finalPartnersIds = []
    let isPartnersInvalid = false

    if (action !== "delete") {
        const partnersArray = Array.isArray(partnersId) 
            ? partnersId 
            : (partnersId ? [partnersId] : []);

        if (partnersArray.length > 0) {
            finalPartnersIds = partnersArray.map(pId => {
                const matched = partnersList.find(p => 
                    p.name.toLowerCase() === pId.toString().toLowerCase() || 
                    p._id === pId
                );
                if (!matched) {
                    isPartnersInvalid = true; 
                }
                return matched ? matched._id : pId;
            });
        }

        

        const isEntityEmpty = !entityId || entityId === '' || entityId.length === 0

        if (isEntityEmpty || !form.checkValidity() || isPartnersInvalid) {
            setFormValid(true)
            if (isEntityEmpty) {
                setEntityErrorKey('projectsEntityInvalid')
            }
            if (isPartnersInvalid) {
                setPartnersErrorKey('projectsPartnersInvalid')
            }
            return
        }
    }

    const project = {
        name, reference, entityId, startDate, endDate,
        programName, programAction, budget, eligiblePercent, partnersId: finalPartnersIds, description,
    };

    try {
        if (elementId && action === "edit") {
            await ProjectsService.updateProject(project, elementId);
        } else if (action === "add") {
            await ProjectsService.addProject(project);
        } else if (action === "delete") {
            await ProjectsService.deleteProject(elementId);
        }

        setFormValid(false);
        onSubmit();
    } catch (error) {  
        const status = error.response?.status
        const msg = error.response?.data?.error?.message || ""
        
        if (status === 412) {
            setShowMsg({ text: 'No se puede borrar un proyecto que está en curso', style: 'danger' })
            setShowAlert(true)
        } else if (msg.includes("Cast to ObjectId failed") && msg.includes("entityId")) {
            setEntityErrorKey('projectsEntityNotFound')
            setFormValid(true)
        } else {
            setShowMsg({ text: error.response?.data?.msg || "An error occurred", style: 'danger' })
            setShowAlert(true)
        }
    }
}

    if (error) {
        return (
            <AlertError error={error} />
        )
    } else if (elementId && !isLoaded) {
        return (
            <AlertLoading isLoaded={isLoaded} />
        )
    }

    return (
        <div>
            <Form noValidate validated={formValid} onSubmit={handleSubmit}>
                {elementId && (
                    <Form.Group className="mb-3" controlId="id">
                        <Form.Label className='fw-semibold'>Id:</Form.Label>
                        <Form.Control
                            type="text"
                            name="id"
                            value={elementId}
                            disabled={"disabled"}
                        />
                    </Form.Group>
                )}

                <Row className="mt-4 mb-4">
                    <Col md={6}>
                        <Form.Group className="mb-3" controlId="name">
                            <PersonLinesFill /><Form.Label className="fw-semibold mb-2 ms-2"><FormattedMessage id="projectsName" defaultMessage="Name" />:</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={name}
                                onChange={handleInputChange}
                                disabled={inputDisabled && ("disabled")}
                                required="required"
                            />
                            <Form.Control.Feedback type="invalid">
                                <FormattedMessage id="projectsNameInvalid" defaultMessage="Provide a project name" />
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3" controlId="reference">
                            <CardHeading /><Form.Label className="fw-semibold mb-2 ms-2"><FormattedMessage id="projectsReference" defaultMessage="Reference" />:</Form.Label>
                            <Form.Control
                                type="text"
                                name="reference"
                                value={reference}
                                onChange={handleInputChange}
                                disabled={inputDisabled && ("disabled")}
                                required="required"
                            />
                            <Form.Control.Feedback type="invalid">
                                <FormattedMessage id="projectsReferenceInvalid" defaultMessage="Provide a project reference" />
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Form.Group className="mb-3" controlId="entityId">
                    <Bank /> <Form.Label className="fw-semibold mb-2 ms-2"><FormattedMessage id="projectsEntity" defaultMessage="Entity" />:</Form.Label>

                    <SearchSelect
                        fieldName={'entityId'}
                        selected={entityId}
                        onChange={handleInputChange}
                        options={entitiesList}
                        disabled={entitiesList.length === 0}

                        className={entityErrorKey !== '' ? 'is-invalid border-danger' : (formValid ? 'is-valid' : '')}
                        placeholder={entitiesList.length === 0 ? intl.formatMessage({ id: "projectsEntitiesNotFound", defaultMessage: "No entities available" }) : intl.formatMessage({ id: "textClickSelect", defaultMessage: "Click to select or search" })}
                    />

                    {entityErrorKey !== '' && (
                        <div className="text-danger small mt-1" style={{ display: 'block', fontWeight: 'normal' }}>
                            <FormattedMessage id={entityErrorKey} defaultMessage="Select an entity" />
                        </div>
                    )}
                </Form.Group>

                <Row className="mt-5 mb-4">
                    <Col md={6}>
                        <Form.Group className="mb-3" controlId="startDate">
                            <Calendar3 /><Form.Label className="fw-semibold mb-2 ms-2"><FormattedMessage id="projectsStartDate" defaultMessage="Start date" />:</Form.Label>
                            <InputDate
                                fieldName='startDate'
                                value={startDate}
                                onChange={handleInputChange}
                                disabled={inputDisabled && ("disabled")}
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                <FormattedMessage id="projectsStartDateInvalid" defaultMessage="Provide a start date" />
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3" controlId="endDate">
                            <Calendar3 /><Form.Label className="fw-semibold mb-2 ms-2"><FormattedMessage id="projectsEndDate" defaultMessage="End date" />:</Form.Label>
                            <InputDate
                                fieldName='endDate'
                                value={endDate}
                                onChange={handleInputChange}
                                disabled={inputDisabled && ("disabled")}
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                <FormattedMessage id="projectsEndDateInvalid" defaultMessage="Provide an end date" />
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Form.Group className="mb-3" controlId="programName">
                    <Diagram2 /><Form.Label className="fw-semibold mb-2 ms-2"><FormattedMessage id="projectsProgramName" defaultMessage="Program name" />:</Form.Label>
                    <Form.Control
                        type="text"
                        name="programName"
                        value={programName}
                        onChange={handleInputChange}
                        disabled={inputDisabled && ("disabled")}
                        required="required"
                    />
                    <Form.Control.Feedback type="invalid">
                        <FormattedMessage id="projectsProgramNameInvalid" defaultMessage="Provide a program name" />
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="programAction">
                    <Diagram2Fill /><Form.Label className="fw-semibold mb-2 ms-2"><FormattedMessage id="projectsProgramAction" defaultMessage="Program action" />:</Form.Label>
                    <Form.Control
                        type="text"
                        name="programAction"
                        value={programAction}
                        onChange={handleInputChange}
                        disabled={inputDisabled && ("disabled")}
                        required="required"
                    />
                    <Form.Control.Feedback type="invalid">
                        <FormattedMessage id="projectsProgramActionInvalid" defaultMessage="Provide a program action" />
                    </Form.Control.Feedback>
                </Form.Group>

                <Row className="mt-4 mb-4">
                    <Col md={6}>
                        <Form.Group className="mb-3" controlId="budget">
                            <CashCoin /><Form.Label className="fw-semibold mb-2 ms-2"><FormattedMessage id="projectsBudget" defaultMessage="Budget" />:</Form.Label>
                            <InputNumber
                                fieldName={"budget"}
                                value={budget}
                                onChange={handleInputChange}
                                disabled={inputDisabled && ("disabled")}
                                required="required"
                            />
                            <Form.Control.Feedback type="invalid">
                                <FormattedMessage id="projectsBudgetInvalid" defaultMessage="Provide a budget" />
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3" controlId="eligiblePercent">
                            <Form.Label className="fw-semibold mb-2 ms-2"><FormattedMessage id="projectsEligiblePercent" defaultMessage="Eligible %" />:</Form.Label>
                            <InputNumber
                                fieldName={"eligiblePercent"}
                                value={eligiblePercent}
                                onChange={handleInputChange}
                                disabled={inputDisabled && ("disabled")}
                                required="required"
                            />
                            <Form.Control.Feedback type="invalid">
                                <FormattedMessage id="projectsEligiblePercentInvalid" defaultMessage="Provide an eligible percentage" />
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Form.Group className="mb-4" controlId="partnersId">
                    <HandThumbsUp /><Form.Label className="fw-semibold mb-2 ms-2"><FormattedMessage id="projectsPartners" defaultMessage="Partners" />:</Form.Label>

                    <SearchSelect
                        fieldName={'partnersId'}
                        selected={partnersId}
                        onChange={handleInputChange}
                        options={partnersList}
                        disabled={partnersList.length === 0}
                        multiple
                        className={partnersErrorKey !== '' ? 'is-invalid border-danger' : ''}
                        placeholder={partnersList.length === 0 ? intl.formatMessage({ id: "projectsPartnersNotFound", defaultMessage: "No partners available" }) : intl.formatMessage({ id: "textClickSelect", defaultMessage: "Click to select or search" })}
                    />

                    {partnersErrorKey !== '' && (
                        <div className="text-danger small mt-1">
                            <FormattedMessage id={partnersErrorKey} />
                        </div>
                    )}
                </Form.Group>

                <Form.Group className="mb-3" controlId="description">
                    <CardText /><Form.Label className="fw-semibold mb-2 ms-2"><FormattedMessage id="projectsDescription" defaultMessage="Description" />:</Form.Label>
                    <Form.Control
                        name="description"
                        value={description}
                        as="textarea"
                        disabled={inputDisabled && ("disabled")}
                        rows={3}
                        onChange={handleInputChange}
                    />
                </Form.Group>

                <AlertMsg message={showMsg.text} variant={showMsg.style} dismissible onCloseHandler={() => setShowAlert(false)} show={showAlert} />

                <div className="d-grid gap-2">
                    {action === "add" && (
                        <Button
                            className="btn btn-dark fw-semibold"
                            type="submit"
                        >
                            <PlusCircle /> {buttonTitle}
                        </Button>
                    )}

                    {action === "edit" && (
                        <Button
                            className="btn btn-primary fw-semibold"
                            type="submit"
                        >
                            <Save2 /> {buttonTitle}
                        </Button>
                    )}

                    {action === "delete" && (
                        <Button
                            className="btn btn-danger fw-semibold"
                            type="submit"
                        >
                            <Trash /> {buttonTitle}
                        </Button>
                    )}
                </div>
            </Form>
        </div>
    )

}

export default ProjectsForm